'use client';

import { useMemo } from 'react';
import { PublicKey } from '@solana/web3.js';

import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { createSwapClient, swapOutputForcesJupiter } from 'src/utils/swap';

/**
 * The client a swap into `outputMint` actually runs on, which is not always the
 * configured one. Quoting with a provider that won't execute the swap prices it
 * against a route nobody builds.
 *
 * Returns a stable instance so the client's lookup-table cache survives
 * re-renders.
 */
export const useEffectiveSwapClient = (outputMint?: PublicKey) => {
	const configuredSwapClient = useVelocityStore((s) => s.swapClient);
	const connection = useVelocityStore((s) => s.connection.current);

	const jupiterSwapClient = useMemo(
		() =>
			connection
				? createSwapClient({ clientType: 'jupiter', connection })
				: null,
		[connection]
	);

	const forcesJupiter = !!outputMint && swapOutputForcesJupiter(outputMint);

	if (!forcesJupiter || configuredSwapClient?.getClientType() === 'jupiter') {
		return configuredSwapClient;
	}

	return jupiterSwapClient ?? configuredSwapClient;
};
